<template>
  <div class="container">
    <div class="py-5 small text-center" v-html="$t('Footer.legalrules')"></div>
  </div>
  <footer class="py-4">

    <div class="navbar px-4 py-0">
      <div class="col">
        <ul class="list-inline mb-0" id="footer-nav">
          <li class="list-inline-item ps-0" v-html="$t('Footer.T&CLink')">
          </li>
          <li class="list-inline-item" v-html="$t('Footer.PrivayPolicyLink')">
          </li>
          <li class="list-inline-item" v-html="$t('Footer.ContactUsLink')">
          </li>
          <li class="list-inline-item" v-html="$t('Footer.DNSLink')">
          </li>
        </ul>
        <p class="mt-1 mb-0">
          <small>{{ $t('Footer.copyrighttext') }} ©{{ new Date().getFullYear() }}.
            {{ $t('Footer.AllrightReserved') }}</small>
        </p>

      </div>
      <div class="footer-right pe-md-5">
        <div class="footer-social-nav">
          <ul class="list-inline m-0 text-center">
            <li>
              <a href="https://www.facebook.com/OcedarClean" class="fb-link social-icon" title="facebook" target="_blank">
                <i class="fab fa-facebook-f"></i>
              </a>
            </li>
            <li>
              <a href="https://www.instagram.com/ocedarclean/" class="ig-link social-icon" title="instagram" target="_blank">
  <i class="fab fa-instagram"></i>

              </a>
            </li>
            <li>
              <a href="https://www.youtube.com/channel/UCcZgn5fv3BUrO_ZLXgGPKTQ" class="yt-link social-icon" title="youtube" target="_blank">
                <i class="fab fa-youtube"></i>
              </a>
            </li>
            <li class="d-block">@OCedarClean</li>
          </ul>
        </div>

      </div>
    </div>
  </footer>
</template>

<script>
//Younet chatbot code apprended in the body
export default {
  mounted() {
    // // Dynamically fetch the translated modelHash
     const modelHash = this.$t('YounetmodelHash');
     const modelImgurl = this.$t('YounetmodelIMg');
     const scriptUrl = `https://widget.younet.ai/index.js?modelHash=${modelHash}&type=bubble&imgUrl=${modelImgurl}&bottom=100`;

    // // Dynamically create the script element
     const script = document.createElement('script');
     script.type = 'module';
     script.src = scriptUrl;

    // // Append the script to the body
     document.body.appendChild(script);
  },
};
</script>
